import moment from 'moment'

const date = {
  new: (date) => moment(date)
}

export default {
  install(Vue) {
    Vue.prototype.$date = date
  }
}
